<!-- Grouped (parallel-array) results render as titled, selectable rows; the group name is the title. -->
<ng-template #groupedRows let-group>
  <div class="grouped-rows-container">
    <h5 class="grouped-rows-title"
      >{{ getItemLabel(group.varName, true) }} ({{ group.value.length }})</h5
    >
    <ul>
      @for (row of group.value; track row) {
        <li class="grouped-row">
          <mat-checkbox
            [checked]="row.checked"
            (click)="checkboxChange($event, row)"
          />
          <div class="grouped-row-fields">
            @for (item of row | sortKeyValue: fieldLabels; track item.key) {
              @if (
                item.key !== 'checked' &&
                displayItemField(group.varName + '.' + item.key)
              ) {
                @switch (getItemType(group.varName + '.' + item.key)) {
                  @case ('custom-drop') {
                    <mat-form-field>
                      <mat-label>{{
                        getItemLabel(group.varName + '.' + item.key)
                      }}</mat-label>
                      <mat-select
                        [required]="row.checked"
                        [disabled]="!row.checked"
                        [(ngModel)]="item.value"
                        (selectionChange)="updateValues($event, row, item)"
                      >
                        @for (
                          dataItem of getItemData(
                            group.varName + '.' + item.key,
                            item
                          );
                          track $index
                        ) {
                          <mat-option [value]="dataItem.value">
                            {{ dataItem.label }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @case ('custom-drop-exp') {
                    <mat-form-field>
                      <mat-label>{{
                        getItemLabel(group.varName + '.' + item.key)
                      }}</mat-label>
                      <mat-select
                        [required]="row.checked"
                        [disabled]="!row.checked"
                        [(ngModel)]="item.value"
                        (selectionChange)="updateValues($event, row, item)"
                      >
                        @for (
                          dataItem of getItemData(
                            group.varName + '.' + item.key,
                            item
                          );
                          track $index
                        ) {
                          <mat-option [value]="dataItem.value">
                            {{ dataItem.label }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @case ('custom-radio') {
                    <div class="radio-field">
                      <mat-label>{{
                        getItemLabel(group.varName + '.' + item.key)
                      }}</mat-label>
                      <mat-radio-group
                        [required]="row.checked"
                        [disabled]="!row.checked"
                        [(ngModel)]="item.value"
                        (selectionChange)="updateValues($event, row, item)"
                      >
                        @for (
                          dataItem of getItemData(
                            group.varName + '.' + item.key,
                            item
                          );
                          track $index
                        ) {
                          <mat-radio-button [value]="dataItem.value">
                            {{ dataItem.label }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                    </div>
                  }
                  @case ('custom-radio-exp') {
                    <div class="radio-field">
                      <mat-label>{{
                        getItemLabel(group.varName + '.' + item.key)
                      }}</mat-label>
                      <mat-radio-group
                        [required]="row.checked"
                        [disabled]="!row.checked"
                        [(ngModel)]="item.value"
                        (selectionChange)="updateValues($event, row, item)"
                      >
                        @for (
                          dataItem of getItemData(
                            group.varName + '.' + item.key,
                            item
                          );
                          track $index
                        ) {
                          <mat-radio-button [value]="dataItem.value">
                            {{ dataItem.label }}
                          </mat-radio-button>
                        }
                      </mat-radio-group>
                    </div>
                  }
                  @case ('custom-currency') {
                    <mat-form-field>
                      <mat-label>{{
                        getItemLabel(group.varName + '.' + item.key)
                      }}</mat-label>
                      <input
                        matInput
                        [maskito]="dollarMask"
                        [disabled]="!row.checked"
                        [required]="row.checked"
                        [(ngModel)]="item.value"
                        (blur)="updateValues($event, row, item)"
                      />
                    </mat-form-field>
                  }
                  @case ('custom-currency-exp') {
                    <mat-form-field>
                      <mat-label>{{
                        getItemLabel(group.varName + '.' + item.key)
                      }}</mat-label>
                      <input
                        matInput
                        [maskito]="dollarMask"
                        [disabled]="!row.checked"
                        [required]="row.checked"
                        [(ngModel)]="item.value"
                        (blur)="updateValues($event, row, item)"
                      />
                    </mat-form-field>
                  }
                  @case ('custom-percentage') {
                    <mat-form-field>
                      <mat-label>{{
                        getItemLabel(group.varName + '.' + item.key)
                      }}</mat-label>
                      <input
                        matInput
                        [maskito]="percentMask"
                        [disabled]="!row.checked"
                        [required]="row.checked"
                        [(ngModel)]="item.value"
                        (blur)="updateValues($event, row, item)"
                      />
                    </mat-form-field>
                  }
                  @case ('custom-percentage-exp') {
                    <mat-form-field>
                      <mat-label>{{
                        getItemLabel(group.varName + '.' + item.key)
                      }}</mat-label>
                      <input
                        matInput
                        [maskito]="percentMask"
                        [disabled]="!row.checked"
                        [required]="row.checked"
                        [(ngModel)]="item.value"
                        (blur)="updateValues($event, row, item)"
                      />
                    </mat-form-field>
                  }
                  @default {
                    <mat-form-field>
                      <mat-label>{{
                        getItemLabel(group.varName + '.' + item.key)
                      }}</mat-label>
                      <input
                        matInput
                        [disabled]="!row.checked"
                        [required]="row.checked"
                        [(ngModel)]="item.value"
                        (blur)="updateValues($event, row, item)"
                      />
                    </mat-form-field>
                  }
                }
              }
            }
          </div>
        </li>
      }
    </ul>
  </div>
</ng-template>
<div mat-dialog-header>
  <h1
    >{{ title }}
    @if (
      currentStep.stepType !== 'upload' &&
      currentStep.stepType !== 'loading' &&
      currentStep.stepType !== 'error'
    ) {
      - <span class="step-title">{{ getStepTitle() }}</span>
    }
  </h1>
</div>
<div
  mat-dialog-content
  class="dialog-container"
  [ngClass]="{
    upload: this.currentStep.stepType === 'upload',
    template: templateMode,
  }"
>
  <div
    [ngClass]="{
      'w-100': this.currentStep.stepType !== 'select',
    }"
  >
    @if (this.currentStep.stepType === 'error') {
      <div class="parse-error-container">
        <div class="mb-2"
          >There was an unexpected error while processing the document(s).</div
        >
        @for (file of errorFiles; track $index) {
          <div class="mb-2"
            ><strong>{{ file }}</strong> failed to process.</div
          >
        }

        @if (checkIfFilesParsed()) {
          <div class="mb-2"
            >Would you like to continue with only the successfully processed
            data?</div
          >
          <button
            type="button"
            mat-raised-button
            color="primary"
            class="mb-2"
            (click)="next(); $event.preventDefault()"
            >Continue</button
          >
        }
        <div class="mb-2">{{ parseErrorText }}</div>
        <button
          type="button"
          mat-button
          class="mb-2"
          color="primary"
          (click)="startOver()"
        >
          <mat-icon>replay</mat-icon>Start Over
        </button>
      </div>
    } @else if (
      this.piiSave ||
      this.normalFileSave ||
      this.piiErrorSave ||
      this.normalFileErrorSave
    ) {
      @if (this.piiErrorSave) {
        <div class="parse-error-container">
          <div class="mb-2">There was an error saving data.</div>
          <div class="mb-2"
            >If you continue to see this error, please reach out to your
            administrator.</div
          >
          <button
            type="button"
            mat-raised-button
            class="mb-2"
            color="primary"
            (click)="submitSelection()"
          >
            <mat-icon>replay</mat-icon>Try again?
          </button>
        </div>
      }
      @if (this.normalFileErrorSave) {
        <div class="parse-error-container">
          @if (uploadedSaveFiles.length) {
            <div class="mb-2">Successfully saved the following file(s):</div>
            @for (savedFile of uploadedSaveFiles; track $index) {
              <div class="mb-2"
                ><strong>{{ savedFile.name }}</strong></div
              >
            }
          }
          @if (errorSaveFiles.length) {
            <div class="mb-2"
              >There was an unexpected error saving the following file(s):</div
            >
            @for (errorFile of errorSaveFiles; track $index) {
              <div class="mb-2"
                ><strong>{{ errorFile.name }}</strong></div
              >
            }
            @if (errorSaveMessage) {
              <div
                class="mb-3 error-message-container"
                [innerHTML]="errorSaveMessage"
              ></div>
            }
          }
          <div class="mb-2"
            >If you continue to see this error, please reach out to your
            administrator.</div
          >
          <div class="mb-2">
            <button
              type="button"
              mat-button
              class="mx-1"
              color="primary"
              (click)="startOver()"
            >
              <mat-icon>replay</mat-icon>Start Over
            </button>
            <button
              type="button"
              mat-raised-button
              class="mx-1"
              color="primary"
              (click)="saveSelectedFiles(true, errorSaveFiles)"
            >
              Retry Failed Files
            </button>
            <button
              type="button"
              mat-raised-button
              class="mx-1"
              (click)="forceCloseModal()"
              >Close and Continue
            </button>
          </div>
        </div>
      }
    } @else if (checkSubscriptions() || currentStep.stepType === 'loading') {
      <div class="loading-container">
        <app-loading-dialog
          [headline]="loadingHeadline"
          [changeContent]="loadingChangeContent"
          [maxTime]="maxTime"
          [showNetworkLoading]="showNetworkLoading"
          [isDialog]="false"
          [loadingVal]="loadingVal"
          [content]="content"
        />
      </div>
    } @else if (this.currentStep.stepType === 'upload') {
      @if (currentFiles.length < +maxFiles) {
        <div
          class="file-info-action-container drop-zone"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <div class="upload-button-container">
            <div class="p-2">{{ instructions }}</div>

            <input
              #miscFileUpload
              type="file"
              class="file-input"
              multiple
              [accept]="fileTypes"
              (change)="onFileSelected($event)"
            />

            <button
              type="button"
              class="operation-button"
              mat-raised-button
              extended
              color="primary"
              [disabled]="currentFiles.length === maxFiles"
              (click)="miscFileUpload.click()"
            >
              <span class="button-label">
                <mat-icon>auto_awesome</mat-icon>
              </span>
            </button>

            <div class="p-2">Drag and drop your files here</div>
          </div>
        </div>
      }
      @if (dupFilesError) {
        <div class="file-info-action-container file-upload-error-text">
          <div>Selection contains a file already selected:</div>
          @for (dupFile of dupFileNames; track dupFile) {
            <div>{{ dupFile }}</div>
          }
        </div>
      } @else if (unacceptableFilesError) {
        <div class="file-info-action-container file-upload-error-text">
          <div>Selection contains an unacceptable file:</div>
          @for (
            unacceptableFile of unacceptableFileNames;
            track unacceptableFile
          ) {
            <div>{{ unacceptableFile }}</div>
          }
        </div>
      }
      @if (tooManyFiles) {
        <div class="file-info-action-container file-upload-error-text">
          <div>Too many files selected, try again.</div>
        </div>
      }
      @if (currentFiles.length > 0) {
        <div class="file-info-action-container">
          <h4>Uploaded Files ({{ currentFiles.length }}/{{ maxFiles }})</h4>
          <!-- prettier-ignore -->
          @for (file of currentFiles; let i = $index; track file) {
              <mat-card appearance="outlined">
                <mat-card-actions class="card-content">
                  {{ file.name
                  }}<button type="button" matIconButton (click)="removeFile($event, i)">
                  <mat-icon>delete</mat-icon>
                  </button>
                  </mat-card-actions>
              </mat-card>
            }
        </div>
      }
    } @else if (this.currentStep.stepType === 'select') {
      @if (currentStep.alerts?.length) {
        <div class="parse-error-container alert-container">
          <div class="mb-2"
            >The following alerts were detected while parsing:</div
          >
          @for (alert of currentStep.alerts; track $index) {
            <div class="negative mb-2"
              ><div><mat-icon>error</mat-icon>{{ alert }}</div></div
            >
          }
          <div class="mb-2"
            >Would you like to continue with the parsed data?</div
          >
          <div class="mb-2">
            <button
              type="button"
              mat-button
              class="mx-1"
              color="primary"
              (click)="startOver()"
            >
              <mat-icon>replay</mat-icon>Start Over
            </button>
            <button
              type="button"
              mat-raised-button
              color="primary"
              class="mx-1"
              (click)="alertsContinue(); $event.preventDefault()"
            >
              Continue
            </button>
          </div>
        </div>
      } @else {
        <div class="container select-doc-item-container">
          <div class="row">
            <h4>{{ selectTitle }}</h4>
            @if (itemType === 'results') {
              <mat-radio-group
                aria-labelledby="select-radio-group-label"
                class="select-radio-group w-100"
                [(ngModel)]="userSelectedItem"
              >
                @for (
                  result of itemsToSelect[this.currentStep.file];
                  track result
                ) {
                  <mat-radio-button
                    class="select-radio-button"
                    [value]="result"
                  >
                    <div>
                      <h5 class="radio-item-title">{{ result | json }}</h5>
                      <div class="radio-item-content"> </div>
                    </div>
                  </mat-radio-button>
                }
              </mat-radio-group>
            }
            <!-- IW -->
            @if (itemType === 'accounts') {
              <mat-radio-group
                aria-labelledby="select-radio-group-label"
                class="select-radio-group w-100"
                [(ngModel)]="userSelectedItem"
              >
                @for (
                  account of itemsToSelect[this.currentStep.file];
                  track account
                ) {
                  <mat-radio-button
                    class="select-radio-button"
                    [value]="account"
                  >
                    <div>
                      <h5 class="radio-item-title">{{
                        account.AccountDescription
                      }}</h5>
                      <div class="radio-item-content">
                        <ul>
                          <li>AccountNumber: {{ account.AccountNumber }}</li>
                          <li
                            >Client: {{ account.Client[0].FirstName }},
                            {{ account.Client[0].LastName }}</li
                          >
                          <li>TotalAmount: {{ account.TotalAmount }}</li>
                        </ul>
                      </div>
                    </div>
                  </mat-radio-button>
                }
              </mat-radio-group>
            }

            @if (itemType === 'exchange') {
              <mat-radio-group
                aria-labelledby="select-radio-group-label"
                class="select-radio-group w-100"
                [(ngModel)]="userSelectedItem"
              >
                @for (
                  exchange of itemsToSelect[this.currentStep.file];
                  track exchange
                ) {
                  <mat-radio-button
                    class="select-radio-button"
                    [value]="exchange"
                  >
                    <div>
                      <h5 class="radio-item-title">{{
                        exchange.CurrentAnnuityDetailsArray_PlanName
                      }}</h5>
                      <div class="radio-item-content">
                        <ul>
                          <li
                            >Carrier:
                            {{
                              exchange.CurrentAnnuityDetailsArray_Carrier
                            }}</li
                          >
                        </ul>
                      </div>
                    </div>
                  </mat-radio-button>
                }
              </mat-radio-group>
            }
            @if (itemType === 'rollover') {
              <mat-radio-group
                aria-labelledby="select-radio-group-label"
                class="select-radio-group w-100"
                [(ngModel)]="userSelectedItem"
              >
                @for (
                  rollover of itemsToSelect[this.currentStep.file];
                  track rollover
                ) {
                  <mat-radio-button
                    class="select-radio-button"
                    [value]="rollover"
                  >
                    <div>
                      <h5 class="radio-item-title">{{
                        rollover[data.varset + '_PlanName']
                      }}</h5>
                      <div class="radio-item-content">
                        <ul>
                          <li
                            >Total Assets:
                            @if (
                              !rollover[data.varset + '_TotalAssets'].includes(
                                '$'
                              )
                            ) {
                              ${{ rollover[data.varset + '_TotalAssets'] }}
                            } @else {
                              {{ rollover[data.varset + '_TotalAssets'] }}
                            }
                          </li>
                        </ul>
                      </div>
                    </div>
                  </mat-radio-button>
                }
              </mat-radio-group>
            }
            @if (itemType === 'insurance') {
              <mat-radio-group
                aria-labelledby="select-radio-group-label"
                class="select-radio-group w-100"
                [(ngModel)]="userSelectedItem"
              >
                @for (
                  insurance of itemsToSelect[this.currentStep.file];
                  track insurance
                ) {
                  <mat-radio-button
                    class="select-radio-button"
                    [value]="insurance"
                  >
                    <div>
                      <h5 class="radio-item-title">{{
                        insurance[data.varset + '_PlanName']
                      }}</h5>
                      <div class="radio-item-content">
                        <ul>
                          <li
                            >Face Amount:
                            @if (
                              !insurance[data.varset + '_FaceAmount'].includes(
                                '$'
                              )
                            ) {
                              ${{ insurance[data.varset + '_FaceAmount'] }}
                            } @else {
                              {{ insurance[data.varset + '_FaceAmount'] }}
                            }
                          </li>
                        </ul>
                      </div>
                    </div>
                  </mat-radio-button>
                }
              </mat-radio-group>
            }
          </div>
        </div>
      }
    } @else if (this.currentStep.stepType === 'parse') {
      @if (currentStep.alerts?.length) {
        <div class="parse-error-container alert-container">
          <div class="mb-2"
            >The following alerts were detected while parsing
            <strong>{{ currentStep.file }}</strong
            >:</div
          >
          @for (alert of currentStep.alerts; track $index) {
            <div class="negative mb-2"
              ><div><mat-icon>error</mat-icon>{{ alert }}</div></div
            >
          }
          <div class="mb-2"
            >Would you like to continue with the parsed data?</div
          >
          <div class="mb-2">
            <button
              type="button"
              mat-button
              class="mx-1"
              color="primary"
              (click)="startOver()"
            >
              <mat-icon>replay</mat-icon>Start Over
            </button>
            <button
              type="button"
              mat-raised-button
              color="primary"
              class="mx-1"
              (click)="alertsContinue(); $event.preventDefault()"
            >
              Continue
            </button>
          </div>
        </div>
      } @else {
        @if (getPdfData()) {
          @if (isSmallScreen$ | async) {
            <mat-tab-group>
              <mat-tab label="Validate Data">
                <div class="container">
                  <div class="parse-title-container row">
                    <h5 class="mt-1">{{ validationTitle }}</h5>
                  </div>
                  <div>
                    <div class="row">
                      @for (
                        fieldItem of selectedItems[this.currentStep.file]
                          .questions;
                        track fieldItem
                      ) {
                        @if (
                          fieldItem.grouped ||
                          displayItemField(fieldItem.field || fieldItem.varName)
                        ) {
                          <div
                            class="{{
                              itemType === 'exchange' ? 'col-4' : ''
                            }} col-lg-12 field-row"
                            [class.sub-details]="
                              fieldItem.hasOwnProperty('checked')
                            "
                          >
                            @if (itemType === 'accounts') {
                              <mat-checkbox
                                [checked]="fieldItem.checked"
                                (click)="checkboxChange($event, fieldItem)"
                              />
                            }
                            <div class="fields-container">
                              @if (fieldItem.grouped) {
                                <ng-container
                                  *ngTemplateOutlet="
                                    groupedRows;
                                    context: { $implicit: fieldItem }
                                  "
                                />
                              }
                              @for (
                                item of fieldItem | sortKeyValue: fieldLabels;
                                track item
                              ) {
                                @if (
                                  item.key !== 'checked' &&
                                  displayItemField(item.key) &&
                                  !arrayObj.isArray(item.value)
                                ) {
                                  @if (fieldItem.PotentialIssue) {
                                    <mat-icon
                                      class="potential-issue-icon"
                                      matTooltip="Potential issue detected with this field while parsing the file"
                                      tabindex="0"
                                      [matTooltipPosition]="'above'"
                                      [matTooltipClass]="'rb-tooltip'"
                                      >error</mat-icon
                                    >
                                  }
                                  @switch (getItemType(item.key)) {
                                    @case ('custom-drop') {
                                      <mat-form-field class="w-100">
                                        <mat-label>{{
                                          getItemLabel(item.key)
                                        }}</mat-label>
                                        <mat-select
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (selectionChange)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        >
                                          @for (
                                            dataItem of getItemData(
                                              item.key,
                                              item
                                            );
                                            track $index
                                          ) {
                                            <mat-option
                                              [value]="dataItem.value"
                                            >
                                              {{ dataItem.label }}
                                            </mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    }
                                    @case ('custom-drop-exp') {
                                      <mat-form-field class="w-100">
                                        <mat-label>{{
                                          getItemLabel(item.key)
                                        }}</mat-label>
                                        <mat-select
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (selectionChange)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        >
                                          @for (
                                            dataItem of getItemData(
                                              item.key,
                                              item
                                            );
                                            track $index
                                          ) {
                                            <mat-option
                                              [value]="dataItem.value"
                                            >
                                              {{ dataItem.label }}
                                            </mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    }
                                    @case ('custom-radio') {
                                      <div class="radio-field">
                                        <mat-label>{{
                                          getItemLabel(item.key)
                                        }}</mat-label>
                                        <mat-radio-group
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (selectionChange)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        >
                                          @for (
                                            dataItem of getItemData(
                                              item.key,
                                              item
                                            );
                                            track $index
                                          ) {
                                            <mat-radio-button
                                              [value]="dataItem.value"
                                            >
                                              {{ dataItem.label }}
                                            </mat-radio-button>
                                          }
                                        </mat-radio-group>
                                      </div>
                                    }
                                    @case ('custom-radio-exp') {
                                      <div class="radio-field">
                                        <mat-label>{{
                                          getItemLabel(item.key)
                                        }}</mat-label>
                                        <mat-radio-group
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (selectionChange)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        >
                                          @for (
                                            dataItem of getItemData(
                                              item.key,
                                              item
                                            );
                                            track $index
                                          ) {
                                            <mat-radio-button
                                              [value]="dataItem.value"
                                            >
                                              {{ dataItem.label }}
                                            </mat-radio-button>
                                          }
                                        </mat-radio-group>
                                      </div>
                                    }
                                    @case ('custom-currency') {
                                      <mat-form-field class="w-100">
                                        <mat-label>{{
                                          getItemLabel(item.key)
                                        }}</mat-label>
                                        <input
                                          matInput
                                          [maskito]="dollarMask"
                                          [disabled]="!fieldItem.checked"
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (blur)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        />
                                      </mat-form-field>
                                    }
                                    @case ('custom-currency-exp') {
                                      <mat-form-field class="w-100">
                                        <mat-label>{{
                                          getItemLabel(item.key)
                                        }}</mat-label>
                                        <input
                                          matInput
                                          [maskito]="dollarMask"
                                          [disabled]="!fieldItem.checked"
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (blur)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        />
                                      </mat-form-field>
                                    }
                                    @case ('custom-percentage') {
                                      <mat-form-field class="w-100">
                                        <mat-label>{{
                                          getItemLabel(item.key)
                                        }}</mat-label>
                                        <input
                                          matInput
                                          [maskito]="percentMask"
                                          [disabled]="!fieldItem.checked"
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (blur)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        />
                                      </mat-form-field>
                                    }
                                    @case ('custom-percentage-exp') {
                                      <mat-form-field class="w-100">
                                        <mat-label>{{
                                          getItemLabel(item.key)
                                        }}</mat-label>
                                        <input
                                          matInput
                                          [maskito]="percentMask"
                                          [disabled]="!fieldItem.checked"
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (blur)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        />
                                      </mat-form-field>
                                    }
                                    @default {
                                      <mat-form-field class="w-100">
                                        <mat-label>{{
                                          getItemLabel(item.key)
                                        }}</mat-label>
                                        <input
                                          matInput
                                          [disabled]="!fieldItem.checked"
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (blur)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        />
                                      </mat-form-field>
                                    }
                                  }
                                }

                                @if (
                                  arrayObj.isArray(item.value) &&
                                  !fieldItem.grouped
                                ) {
                                  <div class="fund-details-container">
                                    <h5>
                                      Fund Details ({{ item.value.length }})
                                    </h5>
                                    @if (item.value.length) {
                                      <ul>
                                        @for (
                                          subItemObj of item.value;
                                          track subItemObj
                                        ) {
                                          <li class="fund-sub-details">
                                            <mat-checkbox
                                              [checked]="subItemObj.checked"
                                              (click)="
                                                checkboxChange(
                                                  $event,
                                                  subItemObj
                                                )
                                              "
                                            />
                                            <div
                                              class="fund-sub-details-container"
                                            >
                                              @for (
                                                subItem of subItemObj
                                                  | sortKeyValue
                                                    : fundDetailsOrder;
                                                track subItem
                                              ) {
                                                @if (
                                                  subItem.key !== 'checked' &&
                                                  displayItemField(
                                                    subItem.key
                                                  ) &&
                                                  !arrayObj.isArray(
                                                    subItem.value
                                                  )
                                                ) {
                                                  <mat-form-field
                                                    class="{{ item.width }}"
                                                  >
                                                    <mat-label>
                                                      {{
                                                        getItemLabel(
                                                          subItem.key
                                                        )
                                                      }}
                                                    </mat-label>
                                                    <input
                                                      matInput
                                                      [disabled]="
                                                        !subItemObj.checked
                                                      "
                                                      [required]="
                                                        subItem.checked
                                                      "
                                                      [(ngModel)]="
                                                        subItem.value
                                                      "
                                                      (blur)="
                                                        updateValues(
                                                          $event,
                                                          subItemObj,
                                                          subItem
                                                        )
                                                      "
                                                    />
                                                  </mat-form-field>
                                                }
                                              }
                                            </div>
                                          </li>
                                        }
                                      </ul>
                                    } @else {
                                      <div>
                                        There were no fund details found.
                                      </div>
                                    }
                                  </div>
                                }
                              }
                            </div>
                          </div>
                        }
                      }
                    </div>
                    <div class="row">
                      @if (
                        selectedItems[`${this.currentStep.file}-PII`]?.questions
                          ?.length
                      ) {
                        <h3 class="pii-title">Client Information</h3>
                        @for (
                          item of selectedItems[`${this.currentStep.file}-PII`]
                            .questions;
                          track item
                        ) {
                          <div
                            class="{{
                              itemType === 'exchange' ? 'col-4' : ''
                            }} col-lg-12 field-row {{ item.width }}"
                          >
                            @if (itemType === 'accounts') {
                              <mat-checkbox
                                [checked]="item.checked"
                                (click)="checkboxChange($event, item)"
                              />
                            }
                            <div class="fields-container">
                              @if (item.key !== 'checked') {
                                @if (item.PotentialIssue) {
                                  <mat-icon
                                    class="potential-issue-icon"
                                    matTooltip="Potential issue detected with this field while parsing the file"
                                    tabindex="0"
                                    [matTooltipPosition]="'above'"
                                    [matTooltipClass]="'rb-tooltip'"
                                  >
                                    error
                                  </mat-icon>
                                }
                                @switch (item.controlType) {
                                  @case ('dropdown') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <mat-select
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (selectionChange)="
                                          updateValues($event, item, item)
                                        "
                                      >
                                        @for (
                                          dataItem of getItemData(
                                            item.key,
                                            item
                                          );
                                          track $index
                                        ) {
                                          <mat-option
                                            [value]="dataItem.value"
                                            >{{ dataItem.label }}</mat-option
                                          >
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  }
                                  @case ('radio') {
                                    <div class="radio-field">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <mat-radio-group
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (selectionChange)="
                                          updateValues($event, item, item)
                                        "
                                      >
                                        @for (
                                          dataItem of getItemData(
                                            item.key,
                                            item
                                          );
                                          track $index
                                        ) {
                                          <mat-radio-button
                                            [value]="dataItem.value"
                                          >
                                            {{ dataItem.label }}
                                          </mat-radio-button>
                                        }
                                      </mat-radio-group>
                                    </div>
                                  }
                                  @case ('currency') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [maskito]="dollarMask"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          updateValues($event, item, item)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('percentage') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [maskito]="percentMask"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          updateValues($event, item, item)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  <!-- the following are specific form fields to PII items -->
                                  @case ('ssn') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        attr.maxlength="11"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          safeBlur(formatSSN, item, $event)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('ein') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        attr.maxlength="10"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          safeBlur(formatEIN, item, $event)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('email') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [disabled]="!item.checked"
                                        [formControl]="item.formCtrl"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          updateValues($event, item, item)
                                        "
                                      />
                                      @if (item.formCtrl.invalid) {
                                        <mat-error>Invalid email</mat-error>
                                      }
                                    </mat-form-field>
                                  }
                                  @case ('address') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          updateValues($event, item, item)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('phone') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          safeBlur(formatPhone, item, $event)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('date') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [matDatepicker]="dp"
                                        [formControl]="item.formCtrl"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                      />
                                      <mat-hint>MM/DD/YYYY</mat-hint>
                                      <mat-datepicker-toggle
                                        matIconSuffix
                                        [for]="dp"
                                      />
                                      <mat-datepicker #dp />
                                      @if (
                                        item.formCtrl.hasError('pastError')
                                      ) {
                                        <mat-error>
                                          Date must be in the future
                                        </mat-error>
                                      } @else if (
                                        item.formCtrl.hasError('futureError')
                                      ) {
                                        <mat-error>
                                          Date must be in the past
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  }
                                  @case ('monthdate') {
                                    <mat-form-field appMonthYearDateDisplay>
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [matDatepicker]="dpm"
                                        [formControl]="item.formCtrl"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                      />
                                      <mat-hint>MM/YYYY</mat-hint>
                                      <mat-datepicker-toggle
                                        matIconSuffix
                                        [for]="dpm"
                                      />
                                      <mat-datepicker
                                        #dpm
                                        startView="multi-year"
                                        (monthSelected)="
                                          setMonthAndYear($event, dpm, item)
                                        "
                                      />
                                      @if (
                                        item.formCtrl.hasError('pastError')
                                      ) {
                                        <mat-error>
                                          Date must be in the future
                                        </mat-error>
                                      } @else if (
                                        item.formCtrl.hasError('futureError')
                                      ) {
                                        <mat-error>
                                          Date must be in the past
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  }
                                  @case ('zip') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        attr.maxlength="10"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          safeBlur(formatZIP, item, $event)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @default {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        attr.maxlength="{{ item.maxLength }}"
                                        minlength="{{ item.minLength }}"
                                        matInput
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          updateValues($event, item, item)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                }
                              }
                            </div>
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="View PDF - {{ this.currentStep.file }}">
                <kendo-pdfviewer
                  class="pdf-viewer"
                  [data]="getPdfData()"
                  [tools]="pdfViewerTools"
                  [zoom]="0.8"
                />
              </mat-tab>
            </mat-tab-group>
          } @else {
            <div class="row split-view-container">
              <div class="col-6 split-view-item split-view-fields">
                <div class="container">
                  <div class="parse-title-container row">
                    <h5 class="mt-1">{{ validationTitle }}</h5>
                  </div>
                  <div>
                    <div class="row">
                      @for (
                        fieldItem of selectedItems[this.currentStep.file]
                          .questions;
                        track fieldItem
                      ) {
                        @if (
                          fieldItem.grouped ||
                          displayItemField(fieldItem.field || fieldItem.varName)
                        ) {
                          <div
                            class="{{
                              itemType === 'exchange' ? 'col-4' : ''
                            }} col-lg-12 field-row"
                            [class.sub-details]="
                              fieldItem.hasOwnProperty('checked')
                            "
                          >
                            @if (itemType === 'accounts') {
                              <mat-checkbox
                                [checked]="fieldItem.checked"
                                (click)="checkboxChange($event, fieldItem)"
                              />
                            }
                            <div class="fields-container">
                              @if (fieldItem.grouped) {
                                <ng-container
                                  *ngTemplateOutlet="
                                    groupedRows;
                                    context: { $implicit: fieldItem }
                                  "
                                />
                              }
                              @for (
                                item of fieldItem | sortKeyValue: fieldLabels;
                                track item
                              ) {
                                @if (
                                  item.key !== 'checked' &&
                                  displayItemField(item.key) &&
                                  !arrayObj.isArray(item.value)
                                ) {
                                  @if (fieldItem.PotentialIssue) {
                                    <mat-icon
                                      class="potential-issue-icon"
                                      matTooltip="Potential issue detected with this field while parsing the file"
                                      tabindex="0"
                                      [matTooltipPosition]="'above'"
                                      [matTooltipClass]="'rb-tooltip'"
                                      >error</mat-icon
                                    >
                                  }
                                  @switch (getItemType(item.key)) {
                                    @case ('custom-drop') {
                                      <mat-form-field class="w-100">
                                        <mat-label>
                                          {{ getItemLabel(item.key) }}
                                        </mat-label>
                                        <mat-select
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (selectionChange)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        >
                                          @for (
                                            dataItem of getItemData(
                                              item.key,
                                              item
                                            );
                                            track $index
                                          ) {
                                            <mat-option
                                              [value]="dataItem.value"
                                              >{{ dataItem.label }}</mat-option
                                            >
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    }
                                    @case ('custom-drop-exp') {
                                      <mat-form-field class="w-100">
                                        <mat-label>
                                          {{ getItemLabel(item.key) }}
                                        </mat-label>
                                        <mat-select
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (selectionChange)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        >
                                          @for (
                                            dataItem of getItemData(
                                              item.key,
                                              item
                                            );
                                            track $index
                                          ) {
                                            <mat-option
                                              [value]="dataItem.value"
                                            >
                                              {{ dataItem.label }}
                                            </mat-option>
                                          }
                                        </mat-select>
                                      </mat-form-field>
                                    }
                                    @case ('custom-radio') {
                                      <div class="radio-field">
                                        <mat-label>
                                          {{ getItemLabel(item.key) }}
                                        </mat-label>
                                        <mat-radio-group
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (selectionChange)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        >
                                          @for (
                                            dataItem of getItemData(
                                              item.key,
                                              item
                                            );
                                            track $index
                                          ) {
                                            <mat-radio-button
                                              [value]="dataItem.value"
                                            >
                                              {{ dataItem.label }}
                                            </mat-radio-button>
                                          }
                                        </mat-radio-group>
                                      </div>
                                    }
                                    @case ('custom-radio-exp') {
                                      <div class="radio-field">
                                        <mat-label>
                                          {{ getItemLabel(item.key) }}
                                        </mat-label>
                                        <mat-radio-group
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (selectionChange)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        >
                                          @for (
                                            dataItem of getItemData(
                                              item.key,
                                              item
                                            );
                                            track $index
                                          ) {
                                            <mat-radio-button
                                              [value]="dataItem.value"
                                            >
                                              {{ dataItem.label }}
                                            </mat-radio-button>
                                          }
                                        </mat-radio-group>
                                      </div>
                                    }
                                    @case ('custom-currency') {
                                      <mat-form-field class="w-100">
                                        <mat-label>
                                          {{ getItemLabel(item.key) }}
                                        </mat-label>
                                        <input
                                          matInput
                                          [maskito]="dollarMask"
                                          [disabled]="!fieldItem.checked"
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (blur)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        />
                                      </mat-form-field>
                                    }
                                    @case ('custom-currency-exp') {
                                      <mat-form-field class="w-100">
                                        <mat-label>
                                          {{ getItemLabel(item.key) }}
                                        </mat-label>
                                        <input
                                          matInput
                                          [maskito]="dollarMask"
                                          [disabled]="!fieldItem.checked"
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (blur)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        />
                                      </mat-form-field>
                                    }
                                    @case ('custom-percentage') {
                                      <mat-form-field class="w-100">
                                        <mat-label>
                                          {{ getItemLabel(item.key) }}
                                        </mat-label>
                                        <input
                                          matInput
                                          [maskito]="percentMask"
                                          [disabled]="!fieldItem.checked"
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (blur)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        />
                                      </mat-form-field>
                                    }
                                    @case ('custom-percentage-exp') {
                                      <mat-form-field class="w-100">
                                        <mat-label>
                                          {{ getItemLabel(item.key) }}
                                        </mat-label>
                                        <input
                                          matInput
                                          [maskito]="percentMask"
                                          [disabled]="!fieldItem.checked"
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (blur)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        />
                                      </mat-form-field>
                                    }
                                    @default {
                                      <mat-form-field class="w-100">
                                        <mat-label>
                                          {{ getItemLabel(item.key) }}
                                        </mat-label>
                                        <input
                                          matInput
                                          [disabled]="!fieldItem.checked"
                                          [required]="fieldItem.checked"
                                          [(ngModel)]="item.value"
                                          (blur)="
                                            updateValues(
                                              $event,
                                              fieldItem,
                                              item
                                            )
                                          "
                                        />
                                      </mat-form-field>
                                    }
                                  }
                                }

                                @if (
                                  arrayObj.isArray(item.value) &&
                                  !fieldItem.grouped
                                ) {
                                  <div class="fund-details-container">
                                    <h5>
                                      Fund Details ({{ item.value.length }})
                                    </h5>
                                    @if (item.value.length) {
                                      <ul>
                                        @for (
                                          subItemObj of item.value;
                                          track subItemObj
                                        ) {
                                          <li class="fund-sub-details">
                                            <mat-checkbox
                                              [checked]="subItemObj.checked"
                                              (click)="
                                                checkboxChange(
                                                  $event,
                                                  subItemObj
                                                )
                                              "
                                            />
                                            <div
                                              class="fund-sub-details-container"
                                            >
                                              @for (
                                                subItem of subItemObj
                                                  | sortKeyValue
                                                    : fundDetailsOrder;
                                                track subItem
                                              ) {
                                                @if (
                                                  subItem.key !== 'checked' &&
                                                  displayItemField(
                                                    subItem.key
                                                  ) &&
                                                  !arrayObj.isArray(
                                                    subItem.value
                                                  )
                                                ) {
                                                  <mat-form-field
                                                    class="{{ item.width }}"
                                                  >
                                                    <mat-label>
                                                      {{
                                                        getItemLabel(
                                                          subItem.key
                                                        )
                                                      }}
                                                    </mat-label>
                                                    <input
                                                      matInput
                                                      [disabled]="
                                                        !subItemObj.checked
                                                      "
                                                      [required]="
                                                        subItemObj.checked
                                                      "
                                                      [(ngModel)]="
                                                        subItem.value
                                                      "
                                                      (blur)="
                                                        updateValues(
                                                          $event,
                                                          subItemObj,
                                                          subItem
                                                        )
                                                      "
                                                    />
                                                  </mat-form-field>
                                                }
                                              }
                                            </div>
                                          </li>
                                        }
                                      </ul>
                                    } @else {
                                      <div>
                                        There were no fund details found.
                                      </div>
                                    }
                                  </div>
                                }
                              }
                            </div>
                          </div>
                        }
                      }
                    </div>
                    <div class="row">
                      @if (
                        selectedItems[`${this.currentStep.file}-PII`]?.questions
                          ?.length
                      ) {
                        <h3 class="pii-title">Client Information</h3>
                        @for (
                          item of selectedItems[`${this.currentStep.file}-PII`]
                            .questions;
                          track item
                        ) {
                          <div
                            class="{{
                              itemType === 'exchange' ? 'col-4' : ''
                            }} col-lg-12 field-row {{ item.width }}"
                          >
                            @if (itemType === 'accounts') {
                              <mat-checkbox
                                [checked]="item.checked"
                                (click)="checkboxChange($event, item)"
                              />
                            }
                            <div class="fields-container">
                              @if (item.key !== 'checked') {
                                @if (item.PotentialIssue) {
                                  <mat-icon
                                    class="potential-issue-icon"
                                    matTooltip="Potential issue detected with this field while parsing the file"
                                    tabindex="0"
                                    [matTooltipPosition]="'above'"
                                    [matTooltipClass]="'rb-tooltip'"
                                  >
                                    error
                                  </mat-icon>
                                }
                                @switch (item.controlType) {
                                  @case ('dropdown') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <mat-select
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (selectionChange)="
                                          updateValues($event, item, item)
                                        "
                                      >
                                        @for (
                                          dataItem of getItemData(
                                            item.key,
                                            item
                                          );
                                          track $index
                                        ) {
                                          <mat-option [value]="dataItem.value">
                                            {{ dataItem.label }}
                                          </mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  }
                                  @case ('radio') {
                                    <div class="radio-field">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <mat-radio-group
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (selectionChange)="
                                          updateValues($event, item, item)
                                        "
                                      >
                                        @for (
                                          dataItem of getItemData(
                                            item.key,
                                            item
                                          );
                                          track $index
                                        ) {
                                          <mat-radio-button
                                            [value]="dataItem.value"
                                          >
                                            {{ dataItem.label }}
                                          </mat-radio-button>
                                        }
                                      </mat-radio-group>
                                    </div>
                                  }
                                  @case ('currency') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [maskito]="dollarMask"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          updateValues($event, item, item)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('percentage') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [maskito]="percentMask"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          updateValues($event, item, item)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  <!-- the following are specific form fields to PII items -->
                                  @case ('ssn') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        attr.maxlength="11"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          safeBlur(formatSSN, item, $event)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('ein') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        attr.maxlength="10"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          safeBlur(formatEIN, item, $event)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('email') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [disabled]="!item.checked"
                                        [formControl]="item.formCtrl"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          updateValues($event, item, item)
                                        "
                                      />
                                      @if (item.formCtrl.invalid) {
                                        <mat-error>Invalid email</mat-error>
                                      }
                                    </mat-form-field>
                                  }
                                  @case ('address') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          updateValues($event, item, item)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('phone') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          safeBlur(formatPhone, item, $event)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('date') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [matDatepicker]="dp"
                                        [formControl]="item.formCtrl"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                      />
                                      <mat-hint>MM/DD/YYYY</mat-hint>
                                      <mat-datepicker-toggle
                                        matIconSuffix
                                        [for]="dp"
                                      />
                                      <mat-datepicker
                                        #dp
                                        panelClass="example-month-picker"
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('monthdate') {
                                    <mat-form-field
                                      class="{{ item.width }}"
                                      appMonthYearDateDisplay
                                    >
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        [matDatepicker]="dpm"
                                        [formControl]="item.formCtrl"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                      />
                                      <mat-hint>MM/YYYY</mat-hint>
                                      <mat-datepicker-toggle
                                        matIconSuffix
                                        [for]="dpm"
                                      />
                                      <mat-datepicker
                                        #dpm
                                        startView="multi-year"
                                        panelClass="example-month-picker"
                                        (monthSelected)="
                                          setMonthAndYear($event, dpm, item)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @case ('zip') {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        matInput
                                        attr.maxlength="10"
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          safeBlur(formatZIP, item, $event)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                  @default {
                                    <mat-form-field class="w-100">
                                      <mat-label>
                                        {{ item.label || item.field }}
                                      </mat-label>
                                      <input
                                        attr.maxlength="{{ item.maxLength }}"
                                        minlength="{{ item.minLength }}"
                                        matInput
                                        [disabled]="!item.checked"
                                        [required]="item.checked"
                                        [(ngModel)]="item.value"
                                        (blur)="
                                          updateValues($event, item, item)
                                        "
                                      />
                                    </mat-form-field>
                                  }
                                }
                              }
                            </div>
                          </div>
                        }
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 split-view-item pdf-view">
                <kendo-pdfviewer
                  class="pdf-viewer"
                  [data]="getPdfData()"
                  [tools]="pdfViewerTools"
                  [zoom]="0.8"
                />
              </div>
            </div>
          }
        } @else {
          <div class="container">
            <div class="parse-title-container row">
              <h5 class="mt-1">{{ validationTitle }}</h5>
            </div>
            @for (fieldItem of parsedFields; track fieldItem) {
              @if (displayItemField(fieldItem.field || fieldItem.varName)) {
                <div
                  class="{{
                    itemType === 'exchange' ? 'col-4' : ''
                  }} col-lg-12 field-row"
                >
                  @if (itemType === 'accounts') {
                    <mat-checkbox
                      [checked]="fieldItem.checked"
                      (click)="checkboxChange($event, fieldItem)"
                    />
                  }
                  <div class="fields-container">
                    @for (
                      item of fieldItem | sortKeyValue: fieldLabels;
                      track item
                    ) {
                      @if (
                        item.key !== 'checked' &&
                        displayItemField(item.key) &&
                        !arrayObj.isArray(item.value)
                      ) {
                        @if (fieldItem.PotentialIssue) {
                          <mat-icon
                            class="potential-issue-icon"
                            matTooltip="Potential issue detected with this field while parsing the file"
                            tabindex="0"
                            [matTooltipPosition]="'above'"
                            [matTooltipClass]="'rb-tooltip'"
                          >
                            error
                          </mat-icon>
                        }
                        @switch (getItemType(item.key)) {
                          @case ('custom-drop') {
                            <mat-form-field class="w-100">
                              <mat-label>
                                {{ getItemLabel(item.key) }}
                              </mat-label>
                              <mat-select
                                [required]="fieldItem.checked"
                                [(ngModel)]="item.value"
                                (selectionChange)="
                                  updateValues($event, fieldItem, item)
                                "
                              >
                                @for (
                                  dataItem of getItemData(item.key, item);
                                  track $index
                                ) {
                                  <mat-option [value]="dataItem.value">
                                    {{ dataItem.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          }
                          @case ('custom-drop-exp') {
                            <mat-form-field class="w-100">
                              <mat-label>
                                {{ getItemLabel(item.key) }}
                              </mat-label>
                              <mat-select
                                [required]="fieldItem.checked"
                                [(ngModel)]="item.value"
                                (selectionChange)="
                                  updateValues($event, fieldItem, item)
                                "
                              >
                                @for (
                                  dataItem of getItemData(item.key, item);
                                  track $index
                                ) {
                                  <mat-option [value]="dataItem.value">
                                    {{ dataItem.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                          }
                          @case ('custom-radio') {
                            <div class="radio-field">
                              <mat-label>
                                {{ getItemLabel(item.key) }}
                              </mat-label>
                              <mat-radio-group
                                [required]="fieldItem.checked"
                                [(ngModel)]="item.value"
                                (selectionChange)="
                                  updateValues($event, fieldItem, item)
                                "
                              >
                                @for (
                                  dataItem of getItemData(item.key, item);
                                  track $index
                                ) {
                                  <mat-radio-button [value]="dataItem.value">
                                    {{ dataItem.label }}
                                  </mat-radio-button>
                                }
                              </mat-radio-group>
                            </div>
                          }
                          @case ('custom-radio-exp') {
                            <div class="radio-field">
                              <mat-label>
                                {{ getItemLabel(item.key) }}
                              </mat-label>
                              <mat-radio-group
                                [required]="fieldItem.checked"
                                [(ngModel)]="item.value"
                                (selectionChange)="
                                  updateValues($event, fieldItem, item)
                                "
                              >
                                @for (
                                  dataItem of getItemData(item.key, item);
                                  track $index
                                ) {
                                  <mat-radio-button [value]="dataItem.value">
                                    {{ dataItem.label }}
                                  </mat-radio-button>
                                }
                              </mat-radio-group>
                            </div>
                          }
                          @case ('custom-currency') {
                            <mat-form-field class="w-100">
                              <mat-label>
                                {{ getItemLabel(item.key) }}
                              </mat-label>
                              <input
                                matInput
                                [maskito]="dollarMask"
                                [disabled]="!fieldItem.checked"
                                [required]="fieldItem.checked"
                                [(ngModel)]="item.value"
                                (blur)="updateValues($event, fieldItem, item)"
                              />
                            </mat-form-field>
                          }
                          @case ('custom-currency-exp') {
                            <mat-form-field class="w-100">
                              <mat-label>
                                {{ getItemLabel(item.key) }}
                              </mat-label>
                              <input
                                matInput
                                [maskito]="dollarMask"
                                [disabled]="!fieldItem.checked"
                                [required]="fieldItem.checked"
                                [(ngModel)]="item.value"
                                (blur)="updateValues($event, fieldItem, item)"
                              />
                            </mat-form-field>
                          }
                          @case ('custom-percentage') {
                            <mat-form-field class="w-100">
                              <mat-label>
                                {{ getItemLabel(item.key) }}
                              </mat-label>
                              <input
                                matInput
                                [maskito]="percentMask"
                                [disabled]="!fieldItem.checked"
                                [required]="fieldItem.checked"
                                [(ngModel)]="item.value"
                                (blur)="updateValues($event, fieldItem, item)"
                              />
                            </mat-form-field>
                          }
                          @case ('custom-percentage-exp') {
                            <mat-form-field class="w-100">
                              <mat-label>
                                {{ getItemLabel(item.key) }}
                              </mat-label>
                              <input
                                matInput
                                [maskito]="percentMask"
                                [disabled]="!fieldItem.checked"
                                [required]="fieldItem.checked"
                                [(ngModel)]="item.value"
                                (blur)="updateValues($event, fieldItem, item)"
                              />
                            </mat-form-field>
                          }
                          @default {
                            <mat-form-field class="w-100">
                              <mat-label>
                                {{ getItemLabel(item.key) }}
                              </mat-label>
                              <input
                                matInput
                                [disabled]="!fieldItem.checked"
                                [required]="fieldItem.checked"
                                [(ngModel)]="item.value"
                                (blur)="updateValues($event, fieldItem, item)"
                              />
                            </mat-form-field>
                          }
                        }
                      }
                      @if (arrayObj.isArray(item.value)) {
                        <div class="fund-details-container">
                          <h5>Fund Details ({{ item.value.length }})</h5>
                          @if (item.value.length) {
                            <ul>
                              @for (
                                subItemObj of item.value;
                                track subItemObj
                              ) {
                                <li class="fund-sub-details">
                                  <mat-checkbox
                                    [checked]="subItemObj.checked"
                                    (click)="checkboxChange($event, subItemObj)"
                                  />
                                  <div class="fund-sub-details-container">
                                    @for (
                                      subItem of subItemObj
                                        | sortKeyValue: fundDetailsOrder;
                                      track subItem
                                    ) {
                                      @if (
                                        subItem.key !== 'checked' &&
                                        displayItemField(subItem.key) &&
                                        !arrayObj.isArray(subItem.value)
                                      ) {
                                        <mat-form-field class="w-100">
                                          <mat-label>
                                            {{ getItemLabel(subItem.key) }}
                                          </mat-label>
                                          <input
                                            matInput
                                            [disabled]="!subItemObj.checked"
                                            [required]="subItemObj.checked"
                                            [(ngModel)]="subItem.value"
                                            (blur)="
                                              updateValues(
                                                $event,
                                                subItemObj,
                                                subItem
                                              )
                                            "
                                          />
                                        </mat-form-field>
                                      }
                                    }
                                  </div>
                                </li>
                              }
                            </ul>
                          } @else {
                            <div>There were no fund details found.</div>
                          }
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            }
          </div>
        }
      }
    } @else if (this.currentStep.stepType === 'reconcile') {
      <div class="container">
        <div class="parse-title-container row">
          <h5 class="mt-1">
            The following fields processed with different data. Please choose
            the one you would like to use.
          </h5>
          <div class="mt-3">
            <!-- prettier-ignore -->
            @for (duplicate of duplicates; let i = $index; track i) {
              <h6>{{ getItemLabel(duplicate.field) || duplicate.label }}</h6>
              <!-- prettier-ignore -->
              <div class="row dup-item">
              @for (dupVal of duplicate.dupValues; let j = $index; track j) {
                  <div class="col">
                    <p>
                      This value is from:
                      @if (displayFileKeys(dupVal.keys).length > 1) {
                        {{displayFileKeys(dupVal.keys).length}} files
                        <mat-icon
                        #tooltip="matTooltip"
                        matTooltip="{{displayFileKeys(dupVal.keys).join(', ')}}"
                        aria-label="Icon that displays a tooltip of the files this value is from."
                        >
                        help
                        </mat-icon>
                      } @else {
                        {{ displayFileKeys(dupVal.keys) }}
                      }
                    </p>
                    <div class="reconcile-check-item-container">
                      <mat-checkbox
                        [checked]="dupVal.checked"
                        (click)="checkboxReconcile($event, dupVal, i, j)"
                      />
                      <mat-form-field class="w-100">
                        <mat-label>{{getItemLabel(duplicate.field) || duplicate.label}}</mat-label>
                        <input matInput [disabled]="!dupVal.checked" [required]="dupVal.checked" [(ngModel)]="dupVal.value" />
                      </mat-form-field>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
<div mat-dialog-actions class="doc-modal-buttons">
  @if (this.currentStep.stepType === 'parse') {
    <div class="disclosure-text-container">{{ disclosure }}</div>
  }
  <div class="action-buttons-container">
    <div class="cancel-button-container">
      @if (!templateMode) {
        <button
          type="button"
          mat-raised-button
          style="margin-left: auto"
          [disabled]="loading"
          (click)="cancelDialog(); $event.preventDefault()"
        >
          Cancel
        </button>
      }
    </div>
    <div class="nav-button-container">
      @if (
        checkStep('previous') !== 'upload' && currentStepStack.length !== 1
      ) {
        <button
          type="button"
          mat-raised-button
          style="margin-left: auto"
          [disabled]="
            this.currentStep.stepType === 'loading' ||
            this.currentStep.stepType === 'error'
          "
          (click)="back(); $event.preventDefault()"
        >
          Back
        </button>
      }
      <button
        type="button"
        mat-raised-button
        style="margin-left: 10px"
        color="accent"
        [disabled]="checknext()"
        (click)="next(); $event.preventDefault()"
      >
        @if (currentStep.stepType === 'reconcile') {
          Submit
        } @else {
          Next
        }
      </button>
    </div>
  </div>
</div>
<ngx-loading
  [show]="loadingFields || piiSave || normalFileSave"
  [config]="{ fullScreenBackdrop: false }"
/>
